/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowqrtitle3Inputs */

const en_organizerfollowqrtitle3 = /** @type {(inputs: Organizerfollowqrtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow QR`)
};

const de_organizerfollowqrtitle3 = /** @type {(inputs: Organizerfollowqrtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgen-QR`)
};

/**
* | output |
* | --- |
* | "Follow QR" |
*
* @param {Organizerfollowqrtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowqrtitle3 = /** @type {((inputs?: Organizerfollowqrtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowqrtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowqrtitle3(inputs)
	return de_organizerfollowqrtitle3(inputs)
});
export { organizerfollowqrtitle3 as "organizerFollowQrTitle" }